var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"id":"committees"}},[_c('v-container',[_c('base-section-heading',{attrs:{"title":"Organizing Committee","color":"red","align":"left","toColor":true}},[_c('br'),_c('organizing-committee')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }